import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysDossierActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysDossierActionController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/action/{action}'
*/
const ElysDossierActionController = (args: { company: string | number | { id: string | number }, dossier_id: string | number, action: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number, action: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysDossierActionController.url(args, options),
    method: 'get',
})

ElysDossierActionController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/action/{action}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysDossierActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysDossierActionController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/action/{action}'
*/
ElysDossierActionController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number, action: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number, action: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
            action: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
        action: args.action,
    }

    return ElysDossierActionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace('{action}', parsedArgs.action.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysDossierActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysDossierActionController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/action/{action}'
*/
ElysDossierActionController.get = (args: { company: string | number | { id: string | number }, dossier_id: string | number, action: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number, action: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysDossierActionController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysDossierActionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysDossierActionController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/action/{action}'
*/
ElysDossierActionController.head = (args: { company: string | number | { id: string | number }, dossier_id: string | number, action: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number, action: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysDossierActionController.url(args, options),
    method: 'head',
})

export default ElysDossierActionController